(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fur-collection-chapters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fur-collection-chapters')) {
    class FurCollectionChapters extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.tabs = Array.from(this.querySelectorAll('[data-chapter-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-chapter-panel]'));
        this.tabList = this.querySelector('[data-chapter-tablist]');
        this.stage = this.querySelector('[data-chapter-stage]');

        if (!this.tabs.length || !this.panels.length) return;

        this.abortController = new AbortController();
        this.requestToken = 0;
        this.pendingWaits = new Set();
        const signal = this.abortController.signal;

        this.tabList?.setAttribute('role', 'tablist');

        this.tabs.forEach((tab, index) => {
          const panel = this.panels[index];
          if (!panel) return;

          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);

          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index, false);
          }, { signal });

          tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
        });

        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        }

        const initialIndex = Math.max(0, this.tabs.findIndex((tab) => tab.dataset.active === 'true'));
        this.commit(initialIndex);
        this.preparePanel(initialIndex).then((ready) => {
          if (!this.isConnected || ready || this.activeIndex !== initialIndex) return;
          this.panels[initialIndex].dataset.imageState = 'failed';
        });
      }

      disconnectedCallback() {
        this.requestToken += 1;
        this.abortController?.abort();
        Array.from(this.pendingWaits || []).forEach((wait) => wait.finish(false));
        this.pendingWaits?.clear();
        this.abortController = null;
      }

      onKeydown(event, currentIndex) {
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }

      onBlockSelect(event) {
        if (event.detail?.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;

        const blockId = String(event.detail?.blockId || '');
        const index = this.panels.findIndex((panel) => panel.dataset.blockId === blockId);
        if (index >= 0) this.activate(index, false);
      }

      async activate(index, moveFocus) {
        const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        if (!this.tabs[safeIndex] || !this.panels[safeIndex]) return;

        const token = ++this.requestToken;
        const targetTab = this.tabs[safeIndex];

        this.setPending(safeIndex);
        if (moveFocus) targetTab.focus();
        this.centerActiveTab(targetTab);

        if (safeIndex === this.activeIndex) {
          this.setPending(null);
          return;
        }

        const ready = await this.preparePanel(safeIndex);
        if (token !== this.requestToken || !this.isConnected) return;

        const targetPanel = this.panels[safeIndex];
        if (ready) {
          targetPanel.removeAttribute('data-image-state');
        } else {
          targetPanel.dataset.imageState = 'failed';
        }

        this.commit(safeIndex);
        this.setPending(null);
      }

      commit(index) {
        this.activeIndex = index;

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.dataset.active = String(isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.dataset.active = String(isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          panel.inert = !isActive;
        });
      }

      setPending(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const isPending = index !== null && tabIndex === index;
          if (isPending) {
            tab.dataset.pending = 'true';
            tab.setAttribute('aria-busy', 'true');
            tab.tabIndex = 0;
          } else {
            tab.removeAttribute('data-pending');
            tab.removeAttribute('aria-busy');
            tab.tabIndex = index === null && tab.dataset.active === 'true' ? 0 : -1;
          }
        });

        if (index === null) {
          this.stage?.removeAttribute('aria-busy');
        } else {
          this.stage?.setAttribute('aria-busy', 'true');
        }
      }

      async preparePanel(index) {
        const panel = this.panels[index];
        if (!panel) return false;

        const images = Array.from(panel.querySelectorAll('img'));
        if (!images.length) return true;

        panel.removeAttribute('data-image-state');

        images.forEach((image) => {
          image.loading = 'eager';
          image.setAttribute('loading', 'eager');
          image.addEventListener('load', () => {
            if (image.naturalWidth > 0) panel.removeAttribute('data-image-state');
          }, { once: true, signal: this.abortController.signal });
        });

        const decodeTask = Promise.all(images.map((image) => this.decodeImage(image)))
          .then((results) => results.every(Boolean))
          .catch(() => false);

        decodeTask.then((ready) => {
          if (ready && this.isConnected) panel.removeAttribute('data-image-state');
        });

        const timeout = window.Shopify?.designMode ? 1200 : 4500;
        return this.withTimeout(decodeTask, timeout);
      }

      async decodeImage(image) {
        if (image.complete) return image.naturalWidth > 0;

        if (typeof image.decode === 'function') {
          try {
            await image.decode();
          } catch (error) {
            if (image.complete) return image.naturalWidth > 0;
            return this.waitForImage(image);
          }
          return image.naturalWidth > 0;
        }

        return this.waitForImage(image);
      }

      waitForImage(image) {
        return new Promise((resolve) => {
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            resolve(image.naturalWidth > 0);
          };
          image.addEventListener('load', finish, { once: true, signal: this.abortController.signal });
          image.addEventListener('error', finish, { once: true, signal: this.abortController.signal });
          this.abortController.signal.addEventListener('abort', () => resolve(false), { once: true });
        });
      }

      withTimeout(promise, timeout) {
        return new Promise((resolve) => {
          const wait = { done: false, timer: 0, finish: null };
          const finish = (value) => {
            if (wait.done) return;
            wait.done = true;
            window.clearTimeout(wait.timer);
            this.pendingWaits.delete(wait);
            resolve(value);
          };

          wait.finish = finish;
          wait.timer = window.setTimeout(() => finish(false), timeout);
          this.pendingWaits.add(wait);
          promise.then(finish, () => finish(false));
        });
      }

      centerActiveTab(tab) {
        if (!this.tabList || this.tabList.scrollWidth <= this.tabList.clientWidth) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = tab.offsetLeft - (this.tabList.clientWidth - tab.offsetWidth) / 2;
        this.tabList.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    customElements.define('fur-collection-chapters', FurCollectionChapters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      const sections = [];
      if (scope.matches?.('[data-fur-collection-hero]')) sections.push(scope);
      sections.push(...scope.querySelectorAll('[data-fur-collection-hero]'));
      sections.forEach((section) => {
        if (section.dataset.furReady === 'true') return;
        section.dataset.furReady = 'true';
        const media = section.querySelector('[data-fur-collection-media]');
        if (!media || section.dataset.motion !== 'true' || section.classList.contains('fur-collection-hero--concept') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const controller = new AbortController();
        let active = true;
        let queued = false;
        const render = () => {
          queued = false;
          if (!active) return;
          const rect = section.getBoundingClientRect();
          const amount = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
          media.style.transform = `scale(${1.025 + Math.max(0, amount) * .065}) translate3d(0, ${amount * 18}px, 0)`;
        };
        const update = () => {
          if (!queued) {
            queued = true;
            requestAnimationFrame(render);
          }
        };
        const observer = new IntersectionObserver((entries) => {
          active = entries[0].isIntersecting;
          if (active) update();
        }, { rootMargin: '150px' });
        observer.observe(section);
        addEventListener('scroll', update, { passive: true, signal: controller.signal });
        addEventListener('resize', update, { passive: true, signal: controller.signal });
        section.furCollectionCleanup = () => {
          controller.abort();
          observer.disconnect();
        };
        update();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-fur-collection-hero]')
        ? event.target
        : event.target.querySelector('[data-fur-collection-hero]');
      section?.furCollectionCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-detail-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fur-detail-explorer')) {
    customElements.define('fur-detail-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.hotspots = Array.from(this.querySelectorAll('[data-detail-hotspot]'));
        this.markers = Array.from(this.querySelectorAll('[data-detail-marker]'));
        this.panels = Array.from(this.querySelectorAll('[data-detail-panel]'));
        if (!this.hotspots.length || !this.panels.length) return;
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.addEventListener('keydown', (event) => this.handleKeydown(event), options);
        document.addEventListener('shopify:block:select', (event) => this.selectBlock(event), options);
        this.classList.add('is-ready');
        this.activate(0, false, false);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      handleClick(event) {
        const view = event.target.closest('[data-detail-view]');
        if (view && this.contains(view)) {
          this.setView(view.dataset.detailView);
          return;
        }
        const hotspot = event.target.closest('[data-detail-hotspot], [data-detail-marker]');
        if (!hotspot || !this.contains(hotspot)) return;
        this.activate(Number(hotspot.dataset.index), hotspot.hasAttribute('data-detail-marker'));
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.dataset.view === 'compare') {
          event.preventDefault();
          this.setView('whole');
          this.hotspots[this.activeIndex]?.focus({ preventScroll: true });
          return;
        }
        const hotspot = event.target.closest('[data-detail-hotspot]');
        if (!hotspot) return;
        if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const current = Number(hotspot.dataset.index);
        let next = current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.hotspots.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.hotspots.length) % this.hotspots.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.hotspots.length - 1;
        event.preventDefault();
        this.activate(next, true);
      }

      activate(index, moveFocus, zoom = true) {
        const safeIndex = Math.max(0, Math.min(index, this.hotspots.length - 1));
        this.activeIndex = safeIndex;
        this.hotspots.forEach((hotspot, hotspotIndex) => {
          const active = hotspotIndex === safeIndex;
          hotspot.classList.toggle('is-active', active);
          hotspot.setAttribute('aria-selected', active ? 'true' : 'false');
          hotspot.tabIndex = active ? 0 : -1;
        });
        this.markers.forEach((marker, markerIndex) => {
          const active = markerIndex === safeIndex;
          marker.classList.toggle('is-active', active);
          marker.setAttribute('aria-pressed', String(active));
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === safeIndex;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        this.setView(zoom ? 'compare' : 'whole');
        if (moveFocus) this.hotspots[safeIndex]?.focus({ preventScroll: true });
      }

      setView(view) {
        const compare = view === 'compare';
        const selected = this.hotspots[this.activeIndex];
        if (!selected) return;
        const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
        const zoom = compare ? clamp(Number(selected.dataset.zoom) / 100 || 2.4, 1.2, 3.2) : 1;
        const focusX = clamp(Number(selected.dataset.x) || 0, 0, 100);
        const focusY = clamp(Number(selected.dataset.y) || 0, 0, 100);
        const cameraX = clamp(50 - focusX * zoom, 100 * (1 - zoom), 0);
        const cameraY = clamp(50 - focusY * zoom, 100 * (1 - zoom), 0);
        this.dataset.view = compare ? 'compare' : 'whole';
        this.style.setProperty('--detail-camera-x', `${cameraX}%`);
        this.style.setProperty('--detail-camera-y', `${cameraY}%`);
        this.style.setProperty('--detail-camera-zoom', zoom);
        this.style.setProperty('--detail-crop-x', `${-cameraX / zoom}%`);
        this.style.setProperty('--detail-crop-y', `${-cameraY / zoom}%`);
        this.style.setProperty('--detail-crop-size', `${100 / zoom}%`);
        this.querySelector('[data-detail-readout]').textContent = `${zoom.toFixed(1)}×`;
        this.querySelector('[data-detail-caption]').textContent = compare ? selected.dataset.title : this.querySelector('[data-detail-whole-label]').textContent;
        this.querySelectorAll('[data-detail-view]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.detailView === this.dataset.view));
        });
        this.markers.forEach((marker) => { marker.tabIndex = compare ? -1 : 0; });
      }

      selectBlock(event) {
        const blockId = event.detail?.blockId;
        const target = blockId
          ? this.hotspots.find((hotspot) => hotspot.dataset.blockId === blockId)
          : event.target?.closest?.('[data-detail-hotspot]');
        if (!target || !this.contains(target)) return;
        this.activate(Number(target.dataset.index), false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-editorial-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-fur-story]:not([data-story-ready])').forEach((root) => {
        root.dataset.storyReady = 'true';
        const viewport = root.querySelector('.fur-story__viewport');
        const panels = [...root.querySelectorAll('[data-story-panel]')];
        const progress = root.querySelector('.fur-story__progress span');
        const current = root.querySelector('[data-story-current]');
        const previous = root.querySelector('[data-story-prev]');
        const next = root.querySelector('[data-story-next]');
        let dragging = false;
        let startX = 0;
        let startScroll = 0;

        const update = () => {
          const maximum = Math.max(viewport.scrollWidth - viewport.clientWidth, 1);
          const ratio = viewport.scrollLeft / maximum;
          progress.style.transform = `scaleX(${ratio})`;
          let nearest = 0;
          let nearestDistance = Infinity;
          panels.forEach((panel, index) => {
            const distance = Math.abs(panel.offsetLeft - viewport.scrollLeft);
            if (distance < nearestDistance) {
              nearest = index;
              nearestDistance = distance;
            }
            const center = panel.offsetLeft + panel.offsetWidth / 2;
            const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
            const shift = Math.max(-1, Math.min(1, (center - viewportCenter) / viewport.clientWidth));
            panel.style.setProperty('--panel-shift', `${shift * -18}px`);
          });
          current.textContent = String(nearest + 1).padStart(2, '0');
        };

        const scrollToPanel = (direction) => {
          const nearest = panels.reduce((best, panel, index) => {
            const distance = Math.abs(panel.offsetLeft - viewport.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity }).index;
          const target = Math.max(0, Math.min(panels.length - 1, nearest + direction));
          panels[target].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        };

        viewport.addEventListener('scroll', update, { passive: true });
        viewport.addEventListener('pointerdown', (event) => {
          dragging = true;
          startX = event.clientX;
          startScroll = viewport.scrollLeft;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
        });
        viewport.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          viewport.scrollLeft = startScroll - (event.clientX - startX);
        });
        const release = () => {
          dragging = false;
          viewport.classList.remove('is-dragging');
        };
        viewport.addEventListener('pointerup', release);
        viewport.addEventListener('pointercancel', release);
        previous.addEventListener('click', () => scrollToPanel(-1));
        next.addEventListener('click', () => scrollToPanel(1));
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fur-atelier-header')) {
    customElements.define('fur-atelier-header', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.unsubscribeCart?.();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const syncHeight = () => {
          document.body.style.setProperty('--header-height', `${this.getBoundingClientRect().height}px`);
          document.body.style.setProperty('--header-group-height', `${(this.closest('#header-group') || this).getBoundingClientRect().height}px`);
        };
        this.resizeObserver = new ResizeObserver(syncHeight);
        this.resizeObserver.observe(this);
        syncHeight();
        this.disclosures = Array.from(this.querySelectorAll('[data-header-disclosure]'));
        this.addEventListener('toggle', (event) => {
          if (event.target.matches('.fur-header__desktop-nav .fur-header-nav__branch') && event.target.open) {
            this.disclosures.forEach((item) => { item.open = false; });
            this.querySelectorAll('.fur-header__desktop-nav details[open]').forEach((item) => { if (item !== event.target) item.open = false; });
            return;
          }
          if (!this.disclosures.includes(event.target) || !event.target.open) return;
          this.disclosures.forEach((item) => { if (item !== event.target) item.open = false; });
          this.querySelectorAll('.fur-header__desktop-nav details[open]').forEach((item) => { item.open = false; });
          event.target.querySelector('input[type="search"]')?.focus({ preventScroll: true });
        }, { ...options, capture: true });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-header-close]');
          if (button) this.closePanel(button.closest('[data-header-disclosure]'), true);
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
        document.addEventListener('focusin', (event) => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const open = event.target.closest('details[open]');
          if (open) { event.preventDefault(); this.closePanel(open, true); }
        }, options);
        this.addEventListener('submit', (event) => {
          if (this.dataset.designMode !== 'true' || !event.target.matches('.fur-header__localization-form')) return;
          event.preventDefault();
          event.target.querySelector('[data-header-editor-note]').hidden = false;
        }, options);
        window.addEventListener('pageshow', () => this.closeAll(), options);
        window.addEventListener('focus', () => this.refreshCart(), options);
        document.addEventListener('cart:updated', () => this.refreshCart(), options);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.cartRequest?.abort();
        this.unsubscribeCart?.();
        this.resizeObserver?.disconnect();
        if (!document.querySelector('fur-atelier-header')) {
          document.body.style.removeProperty('--header-height');
          document.body.style.removeProperty('--header-group-height');
        }
      }
      closePanel(panel, focus = false) {
        if (!panel) return;
        panel.open = false;
        if (focus) panel.querySelector('summary')?.focus({ preventScroll: true });
      }
      closeAll() {
        this.querySelectorAll('details[open]').forEach((panel) => this.closePanel(panel));
      }
      async refreshCart() {
        if (!this.querySelector('[data-header-cart-count]') || this.dataset.designMode === 'true') return;
        this.cartRequest?.abort();
        this.cartRequest = new AbortController();
        try {
          const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: this.cartRequest.signal });
          if (!response.ok) return;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count) || cart.item_count < 0 || !this.isConnected) return;
          this.querySelectorAll('[data-header-cart-count]').forEach((count) => { count.textContent = String(cart.item_count); });
        } catch (_) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-journal"] && !Shopify.designMode) return;
  try {
    
  const initialiseFurJournal = (root) => {
    if (!root || root.dataset.motionInitialised === 'true') return;
    root.dataset.motionInitialised = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('fur-journal-motion');
    const elements = root.querySelectorAll('.fur-journal__reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    elements.forEach((element) => observer.observe(element));
  };

  document.querySelectorAll('[data-fur-journal]').forEach(initialiseFurJournal);
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFurJournal(event.target.querySelector('[data-fur-journal]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fur-lookbook-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fur-lookbook-gallery')) {
    customElements.define('fur-lookbook-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.track = this.querySelector('[data-lookbook-track]');
        this.cards = Array.from(this.querySelectorAll('[data-lookbook-card]'));
        this.previousButton = this.querySelector('[data-lookbook-previous]');
        this.nextButton = this.querySelector('[data-lookbook-next]');
        this.currentCopy = this.querySelector('[data-lookbook-current]');
        this.announcement = this.querySelector('[data-lookbook-announcement]');
        this.progress = this.querySelector('[data-lookbook-progress]');
        this.index = 0;
        this.frame = 0;
        if (!this.track || !this.cards.length) return;
        const options = { signal: this.controller.signal };
        this.previousButton?.addEventListener('click', () => this.move(-1), options);
        this.nextButton?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.requestUpdate(), { ...options, passive: true });
        window.addEventListener('resize', () => this.requestUpdate(), { ...options, passive: true });
        document.addEventListener('shopify:block:select', (event) => this.selectBlock(event), options);
        this.classList.add('is-ready');
        this.update(0);
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update(this.nearestIndex());
        });
      }

      nearestIndex() {
        const trackBox = this.track.getBoundingClientRect();
        const trackCenter = trackBox.left + trackBox.width / 2;
        let nearest = 0;
        let distance = Number.POSITIVE_INFINITY;
        this.cards.forEach((card, index) => {
          const box = card.getBoundingClientRect();
          const cardDistance = Math.abs(box.left + box.width / 2 - trackCenter);
          if (cardDistance < distance) {
            distance = cardDistance;
            nearest = index;
          }
        });
        return nearest;
      }

      update(index) {
        this.index = Math.max(0, Math.min(index, this.cards.length - 1));
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === this.index;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-current', active ? 'true' : 'false');
        });
        const current = String(this.index + 1).padStart(2, '0');
        const total = String(this.cards.length).padStart(2, '0');
        if (this.currentCopy) this.currentCopy.textContent = current;
        if (this.announcement) {
          const template = this.announcement.dataset.labelTemplate || '__CURRENT__ / __TOTAL__';
          this.announcement.textContent = template.replace('__CURRENT__', String(this.index + 1)).replace('__TOTAL__', String(this.cards.length));
        }
        this.style.setProperty('--lookbook-progress', String((this.index + 1) / this.cards.length));
        if (this.previousButton) this.previousButton.disabled = this.index === 0;
        if (this.nextButton) this.nextButton.disabled = this.index === this.cards.length - 1;
      }

      move(direction) {
        const target = Math.max(0, Math.min(this.index + direction, this.cards.length - 1));
        this.scrollToCard(this.cards[target]);
      }

      scrollToCard(card) {
        if (!card) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const smooth = this.dataset.motion === 'true' && !reduced;
        const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      }

      selectBlock(event) {
        const blockId = event.detail?.blockId;
        const target = blockId
          ? this.cards.find((card) => card.dataset.blockId === blockId)
          : event.target?.closest?.('[data-lookbook-card]');
        if (!target || !this.contains(target)) return;
        this.update(this.cards.indexOf(target));
        this.scrollToCard(target);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist-page"]) return;
  try {
    
  class WishlistView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.gridViewContainer = this.querySelector('[data-wishlist-items-grid-display]');
      this.wishlistPaginateContainer = document.getElementById('wishlist-paginate');
      this.viewCols = [...this.querySelectorAll('[data-col]')];

      this.wishlistContainer = this.closest('[data-wishlist-container]');
      this.wishlistFooter = document.querySelector('[data-wishlist-footer]');

      this.viewCols.forEach(viewCol => {
        viewCol.addEventListener('click', this.onViewColClick.bind(this));
      });

      window.addEventListener('resize', theme.utils.rafThrottle(this.onResize.bind(this)));

      this.initWishlistPage();
    }

    getMaxColOnSize() {
      const availableViewCols = this.viewCols.filter(view => {
        return getComputedStyle(view, null).getPropertyValue('display') === 'inline-block';
      }).map(view => Number(view.dataset.col));

      return availableViewCols[availableViewCols.length - 1];
    }

    onResize() {
      const selectedColEl = this.querySelector('[data-col].active');
      if (!selectedColEl) return;
      const selectedCol = Number(selectedColEl.dataset.col);
      const maxColNum = this.getMaxColOnSize();

      if (selectedCol > maxColNum) {
        const target = this.viewCols.find(viewCol => Number(viewCol.dataset.col) === maxColNum);
        if (target) target.click();
      }
    }

    onViewColClick(event) {
      const viewCol = event.target;
      const col = Number(viewCol.dataset.col);

      this.switchViewListGrid(col === 1);
      this.setPaginationAndHeadingView(col === 1);
      this.paginationForList(col === 1);
      this.setGridColumns(col);
      this.setActiveViewCol(viewCol);
    }

    switchViewListGrid(isList) {
      if (isList) {
        this.gridViewContainer.classList.add('productList');
        return;
      }

      this.gridViewContainer.classList.remove('productList');
    }

    setGridColumns(col) {
      this.gridViewContainer.style.setProperty('--grid-columns', col);
    }

    setActiveViewCol(colElement) {
      this.viewCols.forEach(col => col.classList.remove('active'));
      colElement.classList.add('active');
    }

    setPaginationAndHeadingView(isList) {
      if (isList) {
        this.wishlistPaginateContainer.style.display = 'flex';
        return;
      }

      this.wishlistPaginateContainer.style.display = 'none';
    }

    paginationForList(isList) {
      const items = this.gridViewContainer.querySelectorAll('.product');
      const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage);

      if (isList && currentPage) {
        items.forEach((item, index) => {
          if (index >= (currentPage - 1) * 3 && index < currentPage * 3) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      } else {
        items.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    async initWishlistPage() {
      if (typeof(Storage) !== 'undefined') {
        const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

        if (wishlistList.length > 0) {
          try {
            await Promise.all(wishlistList.map((handle, index) => this.setProductForWishlistPage(handle, index, wishlistList.length)));
            this.calculateCard06Padding();

            this.gridViewContainer.classList.add('is-loaded');
            this.wishlistPagination();
            this.setDefaultLayout();

            document.addEventListener('update:pagination', this.wishlistPagination.bind(this));
            document.addEventListener('add:wishlist-item', async (event) => {
              const handle = event.detail.handle;
              await this.setProductForWishlistPage(handle);
            });
          } catch(err) {
            console.error(err);
          }
        } else {
          if (this.wishlistContainer) {
            this.wishlistContainer.classList.add('is-empty');
            this.wishlistContainer.innerHTML = `
              <div class="page-margin wishlist-content-empty center">
                <span class="wishlist-content-text">${window.wishlist.empty}</span>
                <div class="wishlist-content-actions">
                  <a class="button" href="${window.routes.collection_all}">
                    ${window.wishlist.continue_shopping}
                  </a>
                </div>
              </div>
            `;
          }

          if (this.wishlistFooter) this.wishlistFooter.style.display = 'none';
        }
      } else {
        alert('Sorry! No web storage support..');
      }
    }

    setDefaultLayout() {
      const defaultDesktopCol = parseInt(this.dataset.defaultDesktopCol);
      const maxCol = this.getMaxColOnSize();
      const defaultCol = (defaultDesktopCol <= maxCol) ? defaultDesktopCol : maxCol;

      const targetViewCol = this.viewCols.find(viewCol => parseInt(viewCol.dataset.col) === defaultCol );
      if (targetViewCol) {
        targetViewCol.click();
      }
    }

    async setProductForWishlistPage(handle, index, wishlistListLength) {
      try {

        const res = await fetch(`${window.routes.shop_origin}/products/${handle}?view=block_wishlist_card`);
        const data = await res.text();
        const parser = new DOMParser();
        
        const parsedDoc = parser.parseFromString(data, 'text/html');
        const productHTML = parsedDoc.querySelectorAll('#MainContent .card--block')[0];

        this.gridViewContainer.appendChild(productHTML);
        productHTML.dataset.productHandle = handle;

        this.updateProductForWishlistPage();

        const item = this.wishlistContainer.querySelector(`.card--block[data-product-handle="${handle}"]`);

        if (item != null) {
          item.classList.add('wishlist-added');
          item.querySelector('.text').textContent = window.wishlist.added;
          item.classList.add('is-in-grid');
          productHTML.dataset.wishlistAdded = `wishlist-${item.dataset.productId}`;
        }

      } catch (err) {
        console.error(err);
      }
    }

    updateProductForWishlistPage() {
      const sectionFetcher = document.querySelector('section-fetcher');
      
      if (sectionFetcher && typeof sectionFetcher.initialize === 'function') {
        sectionFetcher.initialize();
      } else {
        console.error('WishlistView: No section fetcher component found or initialize method not available');
      }
    }

    wishlistPagination() {
      const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

      this.wishlistPaginateContainer.setAttribute('data-current-page', 1);
      while (this.wishlistPaginateContainer.firstChild) {
        this.wishlistPaginateContainer.removeChild(this.wishlistPaginateContainer.firstChild);
      }

      if (!this.gridViewContainer.classList.contains('productList')) return;
      this.gridViewContainer.classList.remove('is-loaded');

      this.totalPages = Math.ceil(wishlistList.filter(item => item != null).length / 3);

      if (this.totalPages <= 1) {
        [...this.gridViewContainer.children].forEach(child => {
          child.style.display = 'block';
        });
        this.gridViewContainer.classList.add('is-loaded');
        return;
      }

      this.gridViewContainer.classList.add('is-loaded');
    }

    paginateToPages(nextPageNumber = null) {
      const children = [...this.gridViewContainer.children];

      if (nextPageNumber == null) {
        children.forEach((element, index) => {
          if (index >= 3) {
            element.style.display = 'none';
          }
          else {
            element.style.display = 'block';
          }
        });
        return;
      }

      children.forEach((element, index) => {
        if (index >= (nextPageNumber - 1) * 3 && index < nextPageNumber * 3) {
          element.style.display = 'block';
        }
        else {
          element.style.display = 'none';
        }
      });

      if (nextPageNumber === 1) {
        this.wishlistPaginateContainer.querySelector('.prev').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
      else if (nextPageNumber === this.totalPages) {
        this.wishlistPaginateContainer.querySelector('.next').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
      }
      else {
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
    }

    removeAndAddPaginationButtonEvents() {
      const container = this.wishlistPaginateContainer;
      const newContainer = container.cloneNode(true);
      container.parentNode.replaceChild(newContainer, container);
      this.wishlistPaginateContainer = newContainer;

      this.wishlistPaginateContainer.addEventListener('click', (event) => {
        const link = event.target.closest('li a');
        if (!link) return;

        event.preventDefault();
        const li = link.parentElement;
        const isPrev = li.classList.contains('prev');
        const isNext = li.classList.contains('next');
        let pageNumber = parseInt(link.dataset.page);

        const currentButton = this.wishlistPaginateContainer.querySelector('.active');
        let curPage = currentButton ? parseInt(currentButton.querySelector('.link').dataset.page) : 1;

        if (isPrev) {
          pageNumber = curPage - 1;
          if (pageNumber <= 0) pageNumber = 1;
        }

        if (isNext) {
          pageNumber = curPage + 1;
          if (pageNumber > this.totalPages) pageNumber = this.totalPages;
        }

        this.wishlistPaginateContainer.dataset.currentPage = pageNumber;
        this.paginateToPages(pageNumber);

        if (currentButton) {
          currentButton.classList.remove('active');
        }
        const newActive = this.wishlistPaginateContainer.querySelector(`[data-page="${pageNumber}"]`);
        if (newActive && newActive.parentElement) {
          newActive.parentElement.classList.add('active');
        }
      });
    }

    updateShareWishlistViaMail() {
      const regex = /(<([^>]+)>)/ig;
      const addedItems = document.querySelectorAll('[data-wishlist-added]');

      const shareLinkElement = document.querySelector('[data-wishlist-share]');
      let href = 'mailto:?subject= Wish List&body=';

      addedItems.forEach((item, index) => {
        const price = item.querySelector('.price__sale .price__last .price-item')?.textContent || item.querySelector('.price__regular .price__last .price-item')?.textContent;
        const title = item.querySelector('[data-product-title]')?.dataset.productTitle;
        const url = item.querySelector('[data-product-url]')?.dataset.productUrl;

        href += encodeURIComponent(title + '\nPrice: ' + price?.replace(regex, '') + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + url +'\n\n');
      });

      shareLinkElement.href = href;
    }

    calculateCard06Padding() {
      if (!document.body.classList.contains('product-card-layout-06')) return;

      const cardAction = document.querySelector('.card .card-action.card-grid__hidden');

      if (cardAction != undefined) {
        cardAction.classList.remove('card-grid__hidden');
        const padding = cardAction.scrollHeight;
        document.querySelector('[data-wishlist-items-grid-display]').style.setProperty('--card-06-padding', padding + 'px');
        cardAction.classList.add('card-grid__hidden');
      }
    }
  }
  if (!customElements.get('wishlist-view')) customElements.define('wishlist-view', WishlistView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length > 0) {
      tabTitles.forEach(title => {
        title.addEventListener('click', function(e) {
          e.preventDefault();
          if (e.currentTarget.classList.contains('is-active')) return;

          const currentIndex = Array.from(tabTitles).indexOf(e.currentTarget);

          tabTitles.forEach(title => {
            title.classList.remove('is-active');
          });

          tabContents.forEach(content => {
            content.classList.remove('is-active');
          });

          tabContents[currentIndex].classList.add('is-active');
          e.currentTarget.classList.add('is-active');
          });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    if (toggleLinks.length > 0) {
      toggleLinks.forEach(toggleLink => {
        toggleLink.addEventListener('click', function(e) {
          e.preventDefault();

          const viewContentType = toggleLink.closest('.toggle-title').dataset.viewContent;
          const content = toggleLink.closest('.toggle-title').nextElementSibling;
          const cloneContent = content.cloneNode(true);
          
          if (viewContentType === 'sidebar') {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            drawerContent.innerHTML = '';
            drawerContent.appendChild(cloneContent);
          } else if (viewContentType === 'popup') {
            const popupContent = document.querySelector('.popup-content-wrapper');
            popupContent.innerHTML = '';
            popupContent.appendChild(cloneContent);
          } else {
            toggleLink.closest('.toggle-title').classList.toggle('is-open');
          }
        });
      });
    }

    // Open video popup
    const modalTemplate = `
      <side-drawer
        class="popup__content drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
          <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
      `;

    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    if (videoOpenPopups.length > 0) {
      videoOpenPopups.forEach(videoOpenPopup => {
        videoOpenPopup.addEventListener('click', function(e) {
          e.preventDefault();

          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');

         const youtubeIframe = `
          <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         `;

         videoWrapper.innerHTML = youtubeIframe;

        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
